import type { ResourceFolderItemsOutput } from '@cotera/api';

export type SidebarFolderTreeItem = ResourceFolderItemsOutput['items'][number];

/** Private vs Shared sections in the Coco sidebar (matches folder list `folderScope`). */
export type SidebarFolderScope = 'private' | 'shared';

/**
 * Whether a chat/agent list row belongs in the sidebar Private or Shared section when unfiled.
 */
export function matchesSidebarUnfiledSection(
  folderId: string | null | undefined,
  folderScope: 'user' | 'org' | 'external' | null | undefined,
  section: SidebarFolderScope
): boolean {
  if (folderId !== null && folderId !== undefined && folderId !== '') {
    return false;
  }
  if (section === 'private') {
    return (
      folderScope === 'user' ||
      folderScope === undefined ||
      folderScope === null
    );
  }
  return folderScope === 'org' || folderScope === 'external';
}
